import assetLoader from '@utils/internalImageLoader'

export const FETCH_FASTAG_PROVIDER = '/api/app/fastag/?type=biller_detail'
export const FIND_FASTAG_PROIVDER_TEXT = 'How to find your FASTag proivder?'
export const CHECK_FASTAG_TEXT = 'CHECK YOUR FASTag'

export const FASTAG_BALANCE_TYPE = 'fastag_balance'
export const AUTO_API_TYPE = 'autoApi'
export const BILLER_DETAIL_TYPE = 'biller_detail'
export const FASTAG_DEEP_LINK_TYPE = 'fastag_deep_link'
export const FASTAG_RECHARCHE_ENTER_AMOUNT_TYPE = 'fastag_recharge_enter_amount_page'

// filterBanks.ts
export const FILTER_BANK = (fastagProvider: any[], searchBank: string) =>
  fastagProvider
    ?.filter(bank => bank?.name?.toLowerCase()?.includes(searchBank?.toLowerCase()))
    .sort((a, b) => a?.name?.toLowerCase()?.localeCompare(b?.name?.toLowerCase()))

export const AUTO_API = (regNo: string) => `/api/app/fastag/?regNo=${regNo}&type=autoApi`

export const CROSS_ICON = '/images/close.png'
export const CROSS_ICON_TEXT = 'Cross icon'

export const FASTAG_CAR_IMG = '/images/icons/fastag-car.png'
export const FASTAG_CAR_IMG_2 = 'https://acko-cms.ackoassets.com/thumbnail_caricon_3b80a11ef4.png?updatedAt=2024-11-19T06%3A20%3A14.917Z'
export const FASTAG_CAR_IMG_TEXT = 'FASTag car image text'

export const BANK_LOGO_TEXT = 'Bank Logo'

export const EDIT_PENCIL_ICON = '/images/edit_change_pencil.svg'
export const EDIT_PENCIL_ICON_TEXT = 'Edit Icon'

export const SCANNER_IMG = '/images/fastag/downloadappbannerFastag.png'
export const SCAN_TO_DOWNLOAD = 'Scan to download'
export const SCANNER_TEXT = 'Scanner IMg'

export const DOWNLOAD_BTN_TEXT = 'Download the ACKO App'

export const BILLER_API = (regNo: string, billerDetailsId: string) =>
  `/api/app/fastag/?regNo=${regNo}&billerId=${billerDetailsId}&type=fastag_balance`

export const PRODUCT_NAME = 'SEO_FASTAG'

export const BHARAT_VEHICLE_PATTERN = /^[2-3][0-9][B][H](([1-9]ddd)|(d[1-9]dd)|(dd[1-9]d)|(ddd[1-9]))[A-HJ-NP-Z]{1,2}$/

export const INDIAN_VEHICLE_PATTERN =
  /^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TG|TN|TS|TR|UA|UK|UP|WB)( *)( *|-)( *)([0-9]{1,2})( *)( *|-)( *)((([a-zA-Z]{1,3})( *)( *|-)( *)([0-9]{1,4}))|([0-9]{4}))$/

export const CHECK_FASTAG_FALLBACK = 'Check FASTag'

export const FASTAG_WIDGET_HEADING = 'What is you vehicle number'

export const INPUT_ICON = '/images/icons/challan_ind.png'

export const INPUT_PLACEHOLDER = 'AB 12 CD 3456'

export const TAP_BTN_EVENT = 'tap_btn_CTA_widget'

export const VIEW_PAGE_EVENT = 'view_page'

export const REGISTRATION_NUMBER_ERROR = 'Registration Number is Invalid'

export const UNABLE_TO_FETCH = 'Unable to fetch details'

export const BIKE_NUMBER_ERROR = 'This is a bike number. Enter a car number'

export const FEATURE_CONFIG = {
  bannerHeading: 'Do FASTag recharge and more',
  bannerSubheading: 'Only on the acko app',
  keyFeatures: [
    {
      icon: `${assetLoader()}/images/icons/Traffic_fines.png`,
      text: 'Recharge FASTag',
      index: 2,
      alt: 'traffic fine',
    },
    {
      icon: `${assetLoader()}/images/icons/border_fastag.png`,
      text: 'Pay traffic challans',
      index: 3,
      alt: 'fatag',
    },
    {
      icon: `${assetLoader()}/images/icons/PUC_validity.png`,
      text: 'PUC expiry alerts',
      index: 4,
      alt: 'puc',
    },
  ],
  downloadScannerImg: '/images/fastag/downloadappbannerFastag.png',
  downloadButtonLink: 'https://ackoapp.onelink.me/TnnH/yrgklzv7',
  downloadButtonText: 'Download the ACKO App',
}

export const ARROW_DOWN_IMG = 'https://acko-cms.ackoassets.com/Chevron_down_fbcc51fae8.svg?updatedAt=2024-11-15T05%3A39%3A36.612Z'
export const TOGGLE_ICON = 'Toggle ICON'

export const DEPOSIT_AMOUNT = '₹150'

export const ICONS = {
  arrowDown: 'https://acko-cms.ackoassets.com/Chevron_down_fbcc51fae8.svg?updatedAt=2024-11-15T05%3A39%3A36.612Z',
  search: '/images/icons/search.png',
  close: '/images/close.png',
}

export const SITE_KEY = '7c7ed18d-afea-409e-9306-91368490a73a'

export const LOGIN_CONFIG_NAME = 'fastag_widget'

export const AUTO_HEADER_KEY = 'x-app-name'
export const AUTO_HEADER_VALUE = 'carbon'

export const TWO_WHEELER = 'TWO_WHEELER'

export const APP_LINK = 'https://ackoapp.onelink.me/TnnH/yrgklzv7'

export const TAP_BTN_ACKO_APP = 'tap_btn_acko_app'

export const PHONE_NUMBER_ENTERED = 'phone_number_entered'

export const ARROW_ICON = 'arrow icon'

export const BANK_LOGO = 'bank logo'

export const FASTAG_NOT_FOUND = 'No FASTag Found'

export const INPUT_ICON_LOGO = 'input icon logo'

export const FASTAG_HEADER_IMG = '/images/icons/fastag-car.png'

export const FASTAG_HEADER_ALT = 'Fastag Car Icon'

export const CHECK_FASTAG_PROVIDER_IMG = '/images/fastag/check-fastag-provider.png'

export const CHECK_FASTAG_PROVIDER_ALT = 'FASTag provider img'

export const SELECT_FASTAG_PROVIDER = 'Select your FASTag provider'

export const SEARCH_BANK_INPUT_PLACEHOLDER = 'Search provider'

export const NO_FASTAG_FOUND = 'No FASTag found!'

export const ERROR_IMG = 'https://acko-cms.ackoassets.com/Error_caution_alert_danger_bf2db076fc.svg?updatedAt=2024-11-19T06%3A20%3A14.625Z'

export const NO_FASTAG_ERROR_ONE = 'it seems you\'ve selected the wrong FASTag provider.'

export const NO_FASTAG_ERROR_TWO = 'Please choose the correct one to check your balance'

export const TRY_AGAIN = 'Try again'

export const SEARCH_RESULT_TEXT = 'Search Result'

export const ALL_FASTAG_PROVIDER = 'All FASTag Provider'

export const ENTER_CAR_NUMBER = 'Enter a car registration to continue'

export const FALLBACK_SOURCE_NAME = 'SEO_FASTAG'

export const FALLBACK_API_KEY = 'f4imWcFNATEZ4F'

export const FALLBACK_PRODUCT_KEY = 'car'

export const APPFLYER_DEEP_LINK = 'https://tinyurl.internal.live.acko.com/api/v1/appflyer_deep_link'

export const DEEP_LINK_VALUE = 'acko.com://fastag_decision_page?reg_num='

export const FASTAG_RECHARGE_PAGE_VALUE = 'acko.com://fastag_recharge_enter_amount_page'

export const DEEP_LINK_ERROR = 'Failed to fetch the deep link'

export const REDIRECTION_DEEP_LINK = 'REDIRECT TO DEFAULT URL'

export const DEEP_LINK_FETCHING_ERROR = 'Error fetching deep link:'

const CAMPAIGN_NAME = {
  SEO_FASTAG: 'SEO_Fastag',
}

const SOURCE_NAME = {
  SEO: 'SEO',
  SEM: 'SEM'
}

export const APP_FLYER_DEFAULT_PAYLOAD = {
  is_app_only: true,
  campaign_name: CAMPAIGN_NAME.SEO_FASTAG,
  source: SOURCE_NAME.SEO
}

export const FASTAG_OWNER = "Owner's name"

export const FASTAG_STATUS = 'FASTag status'

export const MIN_RECHARGE = 'Minimum recharge'

export const MAX_RECHARGE = 'Maximum recharge'

export const AUTH_FASTAG_CLIENT = 'fastag_widget'

export const LOW_BALANCE_TEXT = 'Your FASTag balance is low'

export const SUFFICIENT_BALANCE_TEXT = 'Your FASTag balance is sufficient'

export const FASTAG_LOWEST_SUFFICIENT_BALANCE = 200
